import dotProp from 'dot-prop-immutable';
import * as types from '../../actions/types';

const initialStateForTicket = {
  pastedTextList: [],
};

const actionToTypeMap = {
  SELECT_ASSIGNED_TICKET: 'ASSIGNED',
  SELECT_LIVE_CHAT_TICKET: 'ASSIGNED',
  SELECT_NOMINATED_TICKET: 'NOMINATED',
  SELECT_ALL_TICKET: 'ALL',
};

const initialState = {
  ticketSelection: null,
};

const analyticsTracker = (state = initialState, action) => {
  switch (action.type) {
    case types.CLEAR_UNSENT_MESSAGE:
      if (state[action.ticketId]) {
        return dotProp.delete(state, action.ticketId);
      }

      return state;
    case types.ON_PASTE_TEXT:
      const { ticketId, pastedText } = action;
      const ticketState = state[ticketId] || initialStateForTicket;
      let { pastedTextList } = ticketState;
      pastedTextList = pastedTextList.concat();
      pastedTextList.push(pastedText);

      return dotProp.set(state, ticketId, { pastedTextList });
    case types.SELECT_ASSIGNED_TICKET:
    case types.SELECT_LIVE_CHAT_TICKET:
    case types.SELECT_NOMINATED_TICKET:
    case types.SELECT_ALL_TICKET:
      const ticketType = actionToTypeMap[action.type];
      // don't handle events if it isn't one of our expected types
      if (!ticketType) {
        return state;
      }

      return dotProp.set(state, 'ticketSelection', {
        ticketType,
        ticketId: action.selectedTicketId,
        session: action.session,
      });

    default:
      return state;
  }
};
export default analyticsTracker;
